import { __assign } from "tslib";
import * as React from 'react';
import { Alert } from '../Alert';
import { Markdown } from '../../extra/Markdown';
import { Txt } from '../Txt';
export var WarningField = function (_a) {
    var warning = _a.warning;
    return (React.createElement(Alert, { plaintext: true, warning: true, mb: 2 },
        React.createElement(Markdown, { componentOverrides: {
                p: function (props) { return React.createElement(Txt.p, __assign({}, props, { margin: 0 })); },
            } }, warning)));
};
